import { Badge } from '@/components/ui/badge';
import type { BigQuerySyncJobGql } from '@/graphql/types/bigQuerySyncPreview';
import { formatUnknownJson } from '@/services/bigQuerySyncPreview/formatUnknownJson';
import { bigQuerySyncJobStatusBadgeClass } from '@/services/bigQuerySyncPreview/bigQuerySyncJobStatusBadge';
import { cn } from '@/lib/utils';

type BigQuerySyncJobStatusPanelProps = {
  job: BigQuerySyncJobGql;
  statusLoading: boolean;
};

export function BigQuerySyncJobStatusPanel({
  job,
  statusLoading,
}: BigQuerySyncJobStatusPanelProps) {
  const statsBody = formatUnknownJson(job.stats_json);

  return (
    <div className="rounded-lg border border-border bg-card p-4 shadow-xs">
      <div className="flex flex-wrap items-center gap-2 gap-y-1">
        <h3 className="text-sm font-semibold">Status do job</h3>
        <Badge
          variant="outline"
          className={cn('font-mono', bigQuerySyncJobStatusBadgeClass(job.status))}
        >
          {job.status}
        </Badge>
        {statusLoading ? <span className="text-xs text-muted-foreground">Atualizando…</span> : null}
      </div>

      <p className="mt-2 font-mono text-xs text-muted-foreground">ID: {job.id}</p>

      {job.progress_label ? (
        <p className="mt-3 text-sm font-medium leading-snug">{job.progress_label}</p>
      ) : null}

      {job.error ? (
        <p className="mt-3 rounded-md border border-destructive/40 bg-destructive/10 px-3 py-2 text-sm text-destructive">
          {job.error}
        </p>
      ) : null}

      {statsBody ? (
        <details className="mt-3">
          <summary className="cursor-pointer text-sm font-medium text-muted-foreground">
            Estatísticas (stats_json)
          </summary>
          <pre className="mt-2 max-h-48 overflow-auto rounded-md bg-muted/50 p-3 font-mono text-xs">
            {statsBody}
          </pre>
        </details>
      ) : null}
    </div>
  );
}
